// extracted by mini-css-extract-plugin
export default {"btn":"ModalToolbarBtn_btn__5u1Sx"};